(() => {
  const CHARSET = '01';
  const TOP_LEVEL_LOCK_STEP_MS = 40;
  const MEGA_LOCK_STEP_MS = 12;
  const FRAME_MS = 20;

  function randChar() {
    return CHARSET[Math.floor(Math.random() * CHARSET.length)];
  }

  function scramble(el, lockStepMs) {
    if (el.__scrambling) return;
    const original = el.textContent;
    if (!original || !original.trim()) return;
    el.__scrambling = true;

    // Lock the box to its resting width — substituted glyphs (e.g. '0'/'1')
    // don't render at the same width as the real letters, which otherwise
    // shoves neighboring nav items sideways for the scramble's duration.
    const lockedWidth = Math.ceil(el.getBoundingClientRect().width) + 1;
    el.style.display = 'inline-block';
    el.style.width = lockedWidth + 'px';
    el.style.whiteSpace = 'nowrap';

    const len = original.length;
    let lockedUpTo = 0;
    let frame = 0;
    const totalFrames = Math.ceil((len * lockStepMs) / FRAME_MS) + 4;

    const interval = setInterval(() => {
      frame += 1;
      lockedUpTo = Math.min(len, Math.floor((frame * FRAME_MS) / lockStepMs));

      let out = '';
      for (let i = 0; i < len; i += 1) {
        const ch = original[i];
        if (ch === ' ') {
          out += ' ';
        } else if (i < lockedUpTo) {
          out += ch;
        } else {
          out += randChar();
        }
      }
      el.textContent = out;

      if (lockedUpTo >= len || frame >= totalFrames) {
        clearInterval(interval);
        el.textContent = original;
        el.style.width = '';
        el.style.display = '';
        el.style.whiteSpace = '';
        el.__scrambling = false;
      }
    }, FRAME_MS);
  }

  function bind(selector, lockStepMs) {
    document.querySelectorAll(selector).forEach((el) => {
      if (el.dataset.scrambleBound) return;
      el.dataset.scrambleBound = 'true';
      el.setAttribute('data-scramble', '');
      el.addEventListener('mouseenter', () => scramble(el, lockStepMs));
    });
  }

  function init() {
    bind('.header__inline-menu .header__menu-item span', TOP_LEVEL_LOCK_STEP_MS);
    bind('.mega-menu__link', MEGA_LOCK_STEP_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  // Newsletter popup trigger — opens the real Shopify Forms teaser (shadow
  // DOM app embed) instead of scrolling to a footer anchor. Delegated +
  // capture phase so it works regardless of when the app embed mounts.
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-open-newsletter-popup]');
    if (!trigger) return;
    e.preventDefault();
    const host = document.getElementById('app-embed-container-827229');
    const teaser = host && host.shadowRoot && host.shadowRoot.querySelector('[class*="teaserContainer"]');
    if (teaser) {
      teaser.click();
    } else {
      window.location.href = '/#footer-newsletter';
    }
  }, true);
})();
